'use strict';

define('CrossWindowMessagingFac',[],
    function () {

        /**
         * @ngdoc factory
         * @name TVG.BetslipMain.CrossWindowMessaging
         *
         * @description
         * Service where we register event listeners for the $rootScope.
         */
        function crossWindowMessaging($rootScope, $window, $log) {
            /**
             * @private
             * @description
             * Every time an account balance update is performed in a betslip window we need to notify the "main" window
             * in order to guarantee that other modules get their matching info updated automatically, if needed.
             */
            function _onAccountBalanceUpdate() {
                $rootScope.$on('accountBalance_update', function () {
                    if (!$window.opener || !$window.opener.hasOwnProperty('__rootScope')) {
                        $log.warn('Unable to notify other windows about the account balance update.');
                        return;
                    }
                    // Notify the other windows that the account balance was updated.
                    $window.opener.__rootScope.$emit('accountBalance_update');
                });
            }

            /**
             * @private
             * @description
             * Every time a bet is placed in the betslip window we need to notify the "main" window
             * in order to guarantee that other modules get their matching info updated automatically, if needed.
             */
            function _onBetPlaced() {
                $rootScope.$on('bet_placed', function (event, race) {
                    /*jslint unparam:true*/
                    if (!$window.opener || !$window.opener.hasOwnProperty('__rootScope')) {
                        $log.warn('Unable to notify other windows about the new bet placed.');
                        return;
                    }
                    // Notify the other windows that the account balance was updated.
                    $window.opener.__rootScope.$emit('bet_placed', race);
                });
            }

            return {
                onAccountBalanceUpdate: _onAccountBalanceUpdate,
                onBetPlaced: _onBetPlaced
            };
        }

        crossWindowMessaging.$inject = [
            '$rootScope',
            '$window',
            '$log'
        ];

        return crossWindowMessaging;
    });

